import styled from 'styled-components';

const breakpointDesktop = 960;

const Footer = styled.footer`
  margin-top: 120px;
  min-height: 336px;
  padding: 0 !important;
  
  .gwo-footer__navigation-wrapper {
    margin-bottom: 25px !important;
    flex-direction: column;
    padding: 0 20px;
      
    @media (min-width: ${breakpointDesktop}px) {
      justify-content: space-between;
      flex-direction: row;
      margin: 15px 0 105px 0 !important;
      justify-content: left;
    }
  }
  
  .gwo-footer__copyright-container {
    padding: 0 20px;
    
    @media (min-width: ${breakpointDesktop}px) {
      padding: 0;
    }
  }
  
  .gwo-footer__container {
    max-width: 1280px;
    margin: auto;
    padding: 20px 32px;
    
    @media (min-width: ${breakpointDesktop}px) {
      margin: 0 auto;
    }
  }
  
  .gwo-footer__link-header {
    color: #4A4A56 !important;
    font-weight: normal;
    font-size: 14px !important;
    background-color: transparent !important;
    padding: 0 !important;
    margin: 5px 0 -8px 0 !important;
    
    @media (min-width: ${breakpointDesktop}px) {
      margin: 12px 0 !important;
    }
  }
  
  .gwo-footer__link-header:after{
    border: none !important;
  }
  
  .gwo-footer__links-container {
    background-color: transparent !important;
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
    min-width: 250px;
    
    @media (min-width: ${breakpointDesktop}px) {
      margin-top: 10px !important;
    }
  }
  
  .gwo-footer__navigation-wrapper .gwo-footer__item {
    margin-right: 0 !important;
    margin-top: 3px;
  }
  
  .gwo-footer__navigation-wrapper .gwo-footer__link {
    color: #6A6A6A;
    text-decoration: none;
    font-size: 13px !important;
  }
  
  .gwo-footer__divider {
    background-color: #C2C2C2 !important;
    height: 1px !important;
  }
  
  .gwo-footer__copyright-text {
    color: #999999;
    font-size: 11px !important;
    display: flex !important;
    flex-direction: column;
        
    @media (min-width: ${breakpointDesktop}px) {
      flex-direction: row;
    }
  }
  
  .gwo-footer__copyright-container .gwo-footer__link {
    color: #666666 !important;
    font-size: 11px !important;
  }
  
  .footer-expansion-panel {
    background-color: transparent !important;
    box-shadow: none !important;
  }
  
  .footer-expansion-panel-summary-root {
    padding: 0;
  }
  
  .footer-expansion-panel-summary-content {
    margin: 0 !important;
  }
  
  .footer-expansion-panel-details {
    padding: 0 0 12px 0;
    
    @media (min-width: ${breakpointDesktop}px) {
      padding: 7px 0 28px 0;
    }
  }
  
  .gwo-footer__copyright-text {
    flex-direction: column;
    font-size: 11px !important;
    
    @media (min-width: ${breakpointDesktop}px) {
      flex-direction: row;
    }
  }
    
  .gwo-footer__copyright-container .gwo-footer__item {
    margin-top: 15px;
    
    @media (min-width: ${breakpointDesktop}px) {
        margin: 0 32px 0 0 !important;
    }
  }
  
  .gwo-footer__button {
    background: none !important;
    border: none;
    padding: 0 !important;
    
    &:hover {
      cursor: pointer;
    }
  }
  
  .gwo-footer__copyright-links {
    padding: 0 !important;
    margin-top: 10px;
    
    @media (min-width: ${breakpointDesktop}px) {
      margin: 15px 0 0 0 !important;
    }
  }
`;

export default Footer;
